import React from 'react'

const Eventvendorcoupsdetails = () => {
    return (
        <div>

        </div>
    )
}

export default Eventvendorcoupsdetails
